import React, { useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import axios from 'axios';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { useNavigate } from "react-router-dom";
import { css } from "styled-components/macro"; // eslint-disable-line
import illustration from "images/Sign up.svg";
import logo from "images/hbm logo.png";
import twitterIconImageSrc from "images/twitter-icon.png";
import { ReactComponent as SignUpIcon } from "feather-icons/dist/icons/user-plus.svg";
import Light from "./headers/light";
import { ReactComponent as EyeIcon } from "feather-icons/dist/icons/eye.svg";
import { ReactComponent as EyeOffIcon } from "feather-icons/dist/icons/eye-off.svg";
import Swal from 'sweetalert2';

const Form = tw.form`mx-auto max-w-xs`; // This defines the Form styled component

const Container = tw(ContainerBase)`min-h-screen  text-white font-medium flex justify-center -m-8`;
const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`h-12 mx-auto`;
const MainContent = tw.div`mt-12 flex flex-col items-center`;
const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
const FormContainer = tw.div`w-full flex-1 mt-8`;

const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;
const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold w-full py-4 rounded-lg transition-all duration-300 ease-in-out flex items-center justify-center`}
  ${({ disabled }) => 
    disabled 
      ? tw`bg-gray-400 cursor-not-allowed` // Grayed out when disabled
      : tw`bg-primary-500 text-gray-100 hover:bg-primary-900`} // Normal button when enabled
`;

const IllustrationContainer = tw.div`sm:rounded-r-lg flex-1 bg-[#2c5a78]  text-center hidden lg:flex justify-center`;
const IllustrationImage = styled.div`
  ${props => `background-image: url("${props.imageSrc}");`}
  ${tw`m-12 xl:m-16 w-full max-w-sm bg-contain bg-center bg-no-repeat`}
`;

const Signup = ({
  logoLinkUrl = "#",
  illustrationImageSrc = illustration,
  headingText = "Créer un compte",
  submitButtonText = "Se connecter",
  signupUrl = "login",
  tosUrl = "#",
  privacyPolicyUrl = "#"
}) => {
  // State variables
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [c_password, setC_password] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [role, setRole] = useState("supplier"); // Default role is buyer
  const [isChecked, setIsChecked] = useState(false); // Track checkbox state

  // Toggle function
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate(); // Initialize useNavigate for redirection

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Check if passwords match
    if (password !== c_password) {
        setError("Les mots de passe ne correspondent pas");
        setLoading(false);
        return;
    }

    // Check if the phone number contains only digits
    const phoneRegex = /^[0-9]+$/;
    if (!phoneRegex.test(phone)) {
        setError("Le numéro de téléphone ne doit contenir que des chiffres.");
        setLoading(false);
        return;
    }

    const userData = { name, email, phone, address, password, role }; // Include role

    try {
        const response = await axios.post('https://hbmdijital.online/api/register', userData);

        if (response.status === 201) {
            console.log('Inscription réussie:', response.data);
            const token = response.data.token;
            const user = response.data.user;

            // 🎉 Afficher SweetAlert2
            Swal.fire({
                title: "Inscription réussie!",
                text: "Utilisateur créé avec succès. Veuillez vérifier votre email pour obtenir votre identifiant.",
                icon: "success",
                confirmButtonText: "D'accord",
            }).then(() => {
                navigate("/login"); // Rediriger après la confirmation
            });
        } else {
            setError("Réponse inattendue du serveur");
        }
    } catch (error) {
        if (error.response) {
            console.error('Erreur d\'inscription:', error.response.data);

            // Check if there are errors
            if (error.response.data.errors) {
                const backendErrors = error.response.data.errors;
                let errorMessages = "Veuillez vérifier votre saisie et vous assurer que les données entrées sont correctes.";


                setError(errorMessages.trim());
            } else {
                setError("Une erreur inattendue s'est produite");
            }
        } else if (error.request) {
            console.error('Aucune réponse reçue:', error.request);
            setError("Aucune réponse du serveur");
        } else {
            console.error('Erreur d\'inscription:', error.message);
            setError("Une erreur inattendue s'est produite");
        }
    } finally {
        setLoading(false);
    }
};



  return (
    <AnimationRevealPage>
      <Light />
      <br />
      <br />

      <Container>
        <Content>
          <MainContainer>
            <LogoLink href={logoLinkUrl}>
              <LogoImage src={logo} />
            </LogoLink>
            <MainContent>
              <Heading>{headingText}</Heading>
              {error && <p tw="mt-4 text-red-600 text-center">{error}</p>}

              <FormContainer>
                <Form onSubmit={handleSubmit}>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Nom Complet"
                  />
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                  <Input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Numéro de Téléphone"
                  />
                  <Input
                    type="text"
                    id="address"
                    name="address"
                    required
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Adresse"
                  />
                  <select
                    id="role"
                    name="role"
                    required
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                    tw="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 text-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0"
                  >
                    <option value="" disabled>Choisissez un rôle</option>
                    <option value="buyer">Acheteur</option>
                    <option value="supplier">Distributeur</option>
                  </select>
                  <br />
                  <div style={{ position: "relative" }}>
                    <Input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Mot de passe"
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer"
                      }}
                    >
                      {showPassword ? <EyeOffIcon width={20} height={20} /> : <EyeIcon width={20} height={20} />}
                    </button>
                  </div>

                  <Input
                    type="password"
                    id="password_confirmation"
                    name="password_confirmation"
                    required
                    value={c_password}
                    onChange={(e) => setC_password(e.target.value)}
                    placeholder="Confirmer le mot de passe"
                  />
                  {/* {error && <p tw="mt-4 text-red-600 text-center">{error}</p>} Display error message */}

                  <div className="flex items-center mt-4">
                    <input
                      type="checkbox"
                      id="terms"
                      required
                      checked={isChecked}
                      onChange={() => setIsChecked(!isChecked)}
                      className="mr-2"
                    />
                    <label htmlFor="terms" tw="mt-6 text-xs text-gray-600 text-center">
                        J'ai lu les termes et conditions et regardé la vidéo.
                    </label>
                  </div>

                  <SubmitButton type="submit" disabled={!isChecked}>
  <span className="text">{loading ? "Loading..." : submitButtonText}</span>
</SubmitButton>


                </Form>
                <p tw="mt-6 text-xs text-gray-600 text-center">J'accepte de respecter les conditions d'utilisation et la politique de confidentialité.</p>
                <p tw="mt-8 text-sm text-gray-600 text-center">
                  Avez-vous un compte ?{" "}
                  <a href={signupUrl} tw="border-b border-gray-500 border-dotted">
                    Se connecter
                  </a>
                </p>
              </FormContainer>
            </MainContent>
          </MainContainer>
          <IllustrationContainer>
            <IllustrationImage imageSrc={illustrationImageSrc} />
          </IllustrationContainer>
        </Content>
      </Container>
      <br/>
      <Footer />
    </AnimationRevealPage>
  );
};

export default Signup;
